import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  selectClass: {
    '& select': {
      fontFamily: 'GTAM !important',
      fontSize: '21px',
      width: '296px'
    }
  },
  selectOption: {
    '& option': {
      fontFamily: 'GTAR !important',
      fontSize: '16px'
    },
    '& option:hover': {
      fontFamily: 'GTAM !important',
      background: 'none',
      textDecoration: 'underline'
    }
  }
})
export default useStyles
